import { useSelector } from 'react-redux'

/**
 * `aiFunctionality` is the home-level opt-out from every AI feature. The
 * installed @lmc/ts-common predates it, so `HomeFeatures` (and with it the
 * `Home` type's `features`) has no key for it — read it off a narrow local
 * shape rather than bumping the package for one field.
 */
type HomeAiFunctionality = {
  features?: { aiFunctionality?: { enabled?: boolean } }
}

/**
 * Whether the home may show AI features at all. Gate every AI surface on this
 * in addition to its own feature flag: the flag is our rollout switch, this is
 * the customer's opt-out.
 *
 * Absent means enabled — only an explicit opt-out hides the feature, which is
 * the same default the generation job and the API endpoints apply.
 */
const useHasAiFunctionalityEnabled = () =>
  useSelector(
    (state: { global: { home?: HomeAiFunctionality } }) =>
      state.global.home?.features?.aiFunctionality?.enabled ?? true
  )

export default useHasAiFunctionalityEnabled
